module.exports = __webpack_public_path__ + "static/media/application_6.1eaa833b.png";